import {
  type ApiKey,
  apiKeyListSchema,
  apiKeySchema,
  type CreateApiKeyRequest,
  type CreateApiKeyResponse,
  createApiKeyResponseSchema,
  type UpdateApiKeyRequest,
} from '@ytclip/shared'
import { z } from 'zod'
import { apiRequest } from '@/lib/api-client.ts'

export async function fetchApiKeys(): Promise<ApiKey[]> {
  const response = await apiRequest('/me/keys', apiKeyListSchema)
  return response.data
}

/** The plaintext secret in the response is shown once and never retrievable again. */
export function createApiKey(body: CreateApiKeyRequest): Promise<CreateApiKeyResponse> {
  return apiRequest('/me/keys', createApiKeyResponseSchema, { method: 'POST', body })
}

export function updateApiKey(token: string, body: UpdateApiKeyRequest): Promise<ApiKey> {
  return apiRequest(`/me/keys/${encodeURIComponent(token)}`, apiKeySchema, {
    method: 'PATCH',
    body,
  })
}

export function deleteApiKey(token: string): Promise<void> {
  return apiRequest(`/me/keys/${encodeURIComponent(token)}`, z.undefined(), {
    method: 'DELETE',
  })
}
